<template>
    <selector-popup
            ref="popup"
            header="How you would like to add audio?"
            :items="items"
    >
        <template v-slot:footer>
            <button @click="back" type="button" class="btn btn-mm  btn-primary">Back</button>
        </template>
        <template v-slot:invisibleForms>
            <form enctype="multipart/form-data">
                <input
                        ref="recordAudioHiddenButton"
                        type="file"
                        name="audio"
                        accept="audio/*"
                        capture="user"
                        id="record_audio"
                        style="display: none"
                        @change="onFileFieldChanged"
                />
            </form>
        </template>
    </selector-popup>
</template>

<script>
    import SelectorPopup from "../../../../vue/common_components/SelectorPopup/SelectorPopup";
    import AddMediaSelectorPopupMixin from "./AddMediaSelectorPopupMixin";

    export default {
        name: "AddAudioPopup",
        components: {SelectorPopup},
        mixins: [AddMediaSelectorPopupMixin],
        data() {
            return {
                videoFile: undefined,
                config: Object,
                audioRecordByMediaStreamSupported: false,
            };
        },
        computed: {
            items() {
                if (!this.config?.types?.length) {
                    return [];
                }
                const items = [];
                if (this.audioRecordByMediaStreamSupported) {
                    items.push({
                        label: 'Record<br/>Audio',
                        iconClass: 'fa-microphone',
                        action: 'select',
                        selection: 'record',
                    });
                } else if (this.allowCapture) {
                    items.push({
                        label: 'Record<br/>Audio',
                        iconClass: 'fa-microphone',
                        action: 'function',
                        function: 'recordAudioByDevice',
                    });
                }
                items.push({
                    label: 'Upload<br/>from device',
                    iconClass: 'fa-upload',
                    action: 'select',
                    selection: 'device',
                });
                if (this.config.allow_add_from_library) {
                    items.push({
                        label: 'Add from<br>My Media',
                        iconClass: 'fa-folder-o',
                        action: 'select',
                        selection: 'folder',
                    });
                }
                return items;
            },
        },
        methods: {
            show(config) {
                this.config = config;
                return new Promise((resolve, reject) => {
                    this.reject = reject;
                    this.resolve = resolve;
                    this.$refs.popup.show()
                        .then(item => {
                            if (item.action === 'select') {
                                resolve({
                                    action: 'select',
                                    selection: item.selection,
                                });
                            } else if (item.action === 'function') {
                                if (item.function === 'recordAudioByDevice') {
                                    this.recordAudioByDevice();
                                }
                            }
                        }, reason => {
                            reject(reason);
                        });
                });
            },
            back() {
                this.reject('back');
            },
            onFileFieldChanged(e) {
                this.resolve({
                    action: 'file',
                    file: e.target?.files[0]
                });
            },
            recordAudioByDevice() {
                setTimeout(() => {
                    this.$refs.recordAudioHiddenButton.click();
                }, 20);
            },
        },
        mounted() {
            this.$_detectMediaDeviseSupport('audio')
                .then(supported => {
                    this.audioRecordByMediaStreamSupported = supported;
                });
        }
    };
</script>